import Box from "@mui/material/Box";

const SortAscIcon = props => {
  return (
    <Box {...props}>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.16665 3.5C4.16665 3.36739 4.11397 3.24021 4.0202 3.14645C3.92643 3.05268 3.79926 3 3.66665 3C3.53404 3 3.40686 3.05268 3.31309 3.14645C3.21933 3.24021 3.16665 3.36739 3.16665 3.5V12.293L2.02065 11.146C1.97416 11.0995 1.91897 11.0626 1.85823 11.0375C1.79749 11.0123 1.73239 10.9994 1.66665 10.9994C1.6009 10.9994 1.5358 11.0123 1.47506 11.0375C1.41432 11.0626 1.35914 11.0995 1.31265 11.146C1.26616 11.1925 1.22928 11.2477 1.20412 11.3084C1.17896 11.3692 1.16602 11.4343 1.16602 11.5C1.16602 11.5657 1.17896 11.6308 1.20412 11.6916C1.22928 11.7523 1.26616 11.8075 1.31265 11.854L3.31265 13.853L3.31965 13.86C3.41352 13.9515 3.53977 14.0023 3.67088 14.0011C3.802 14 3.92735 13.9471 4.01965 13.854L6.01965 11.854C6.11353 11.7602 6.16633 11.633 6.16643 11.5004C6.16652 11.3677 6.1139 11.2404 6.02015 11.1465C5.92639 11.0526 5.79918 10.9998 5.6665 10.9997C5.53382 10.9996 5.40653 11.0522 5.31265 11.146L4.16665 12.293V3.5ZM8.16665 4C8.03404 4 7.90686 3.94732 7.81309 3.85355C7.71933 3.75979 7.66665 3.63261 7.66665 3.5C7.66665 3.36739 7.71933 3.24021 7.81309 3.14645C7.90686 3.05268 8.03404 3 8.16665 3H9.16665C9.29926 3 9.42643 3.05268 9.5202 3.14645C9.61397 3.24021 9.66665 3.36739 9.66665 3.5C9.66665 3.63261 9.61397 3.75979 9.5202 3.85355C9.42643 3.94732 9.29926 4 9.16665 4H8.16665ZM8.16665 7C8.03404 7 7.90686 6.94732 7.81309 6.85355C7.71933 6.75979 7.66665 6.63261 7.66665 6.5C7.66665 6.36739 7.71933 6.24021 7.81309 6.14645C7.90686 6.05268 8.03404 6 8.16665 6H11.1666C11.2993 6 11.4264 6.05268 11.5202 6.14645C11.614 6.24021 11.6666 6.36739 11.6666 6.5C11.6666 6.63261 11.614 6.75979 11.5202 6.85355C11.4264 6.94732 11.2993 7 11.1666 7H8.16665ZM8.16665 10C8.03404 10 7.90686 9.94732 7.81309 9.85355C7.71933 9.75979 7.66665 9.63261 7.66665 9.5C7.66665 9.36739 7.71933 9.24021 7.81309 9.14645C7.90686 9.05268 8.03404 9 8.16665 9H13.1666C13.2993 9 13.4264 9.05268 13.5202 9.14645C13.614 9.24021 13.6666 9.36739 13.6666 9.5C13.6666 9.63261 13.614 9.75979 13.5202 9.85355C13.4264 9.94732 13.2993 10 13.1666 10H8.16665ZM7.66665 12.5C7.66665 12.6326 7.71933 12.7598 7.81309 12.8536C7.90686 12.9473 8.03404 13 8.16665 13H15.1666C15.2993 13 15.4264 12.9473 15.5202 12.8536C15.614 12.7598 15.6666 12.6326 15.6666 12.5C15.6666 12.3674 15.614 12.2402 15.5202 12.1464C15.4264 12.0527 15.2993 12 15.1666 12H8.16665C8.03404 12 7.90686 12.0527 7.81309 12.1464C7.71933 12.2402 7.66665 12.3674 7.66665 12.5Z"
          fill="#A6A6A6"
        />
      </svg>
    </Box>
  );
};

const SortDescIcon = props => {
  return (
    <Box {...props}>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.00063 12.5008C4.00063 12.6334 3.94795 12.7605 3.85418 12.8543C3.76042 12.9481 3.63324 13.0008 3.50063 13.0008C3.36802 13.0008 3.24085 12.9481 3.14708 12.8543C3.05331 12.7605 3.00063 12.6334 3.00063 12.5008V3.70776L1.85463 4.85476C1.80814 4.90125 1.75295 4.93812 1.69221 4.96328C1.63148 4.98844 1.56638 5.00139 1.50063 5.00139C1.43489 5.00139 1.36979 4.98844 1.30905 4.96328C1.24831 4.93812 1.19312 4.90125 1.14663 4.85476C1.10014 4.80827 1.06327 4.75308 1.03811 4.69234C1.01295 4.6316 1 4.5665 1 4.50076C1 4.43502 1.01295 4.36992 1.03811 4.30918C1.06327 4.24844 1.10014 4.19325 1.14663 4.14676L3.14663 2.14776L3.15363 2.14076C3.24763 2.04946 3.37383 1.9989 3.50486 2.00002C3.6359 2.00114 3.76121 2.05387 3.85363 2.14676L5.85363 4.14676C5.90012 4.19318 5.93701 4.24831 5.96219 4.30899C5.98738 4.36966 6.00036 4.43471 6.00041 4.50041C6.00046 4.5661 5.98756 4.63117 5.96246 4.69188C5.93737 4.7526 5.90055 4.80777 5.85413 4.85426C5.80771 4.90075 5.75259 4.93764 5.69191 4.96282C5.63123 4.98801 5.56618 5.00099 5.50049 5.00104C5.43479 5.00108 5.36972 4.98819 5.30901 4.96309C5.2483 4.93799 5.19312 4.90118 5.14663 4.85476L4.00063 3.70776V12.5008ZM7.50063 3.50076C7.50063 3.36815 7.55331 3.24098 7.64708 3.14721C7.74085 3.05344 7.86802 3.00076 8.00063 3.00076H15.0006C15.1332 3.00076 15.2604 3.05344 15.3542 3.14721C15.448 3.24098 15.5006 3.36815 15.5006 3.50076C15.5006 3.63337 15.448 3.76055 15.3542 3.85431C15.2604 3.94808 15.1332 4.00076 15.0006 4.00076H8.00063C7.86802 4.00076 7.74085 3.94808 7.64708 3.85431C7.55331 3.76055 7.50063 3.63337 7.50063 3.50076ZM8.00063 6.00076C7.86802 6.00076 7.74085 6.05344 7.64708 6.14721C7.55331 6.24097 7.50063 6.36815 7.50063 6.50076C7.50063 6.63337 7.55331 6.76055 7.64708 6.85431C7.74085 6.94808 7.86802 7.00076 8.00063 7.00076H13.0006C13.1332 7.00076 13.2604 6.94808 13.3542 6.85431C13.448 6.76055 13.5006 6.63337 13.5006 6.50076C13.5006 6.36815 13.448 6.24097 13.3542 6.14721C13.2604 6.05344 13.1332 6.00076 13.0006 6.00076H8.00063ZM8.00063 9.00076C7.86802 9.00076 7.74085 9.05344 7.64708 9.14721C7.55331 9.24097 7.50063 9.36815 7.50063 9.50076C7.50063 9.63337 7.55331 9.76055 7.64708 9.85431C7.74085 9.94808 7.86802 10.0008 8.00063 10.0008H11.0006C11.1332 10.0008 11.2604 9.94808 11.3542 9.85431C11.448 9.76055 11.5006 9.63337 11.5006 9.50076C11.5006 9.36815 11.448 9.24097 11.3542 9.14721C11.2604 9.05344 11.1332 9.00076 11.0006 9.00076H8.00063ZM8.00063 12.0008C7.86802 12.0008 7.74085 12.0534 7.64708 12.1472C7.55331 12.241 7.50063 12.3682 7.50063 12.5008C7.50063 12.6334 7.55331 12.7605 7.64708 12.8543C7.74085 12.9481 7.86802 13.0008 8.00063 13.0008H9.00063C9.13324 13.0008 9.26042 12.9481 9.35419 12.8543C9.44795 12.7605 9.50063 12.6334 9.50063 12.5008C9.50063 12.3682 9.44795 12.241 9.35419 12.1472C9.26042 12.0534 9.13324 12.0008 9.00063 12.0008H8.00063Z"
          fill="#A6A6A6"
        />
      </svg>
    </Box>
  );
};

const ArrowCircleDownIcon = props => {
  return (
    <Box {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 8L11 8L11 12.2L9.4 10.6L8 12L12 16L16 12L14.6 10.6L13 12.2L13 8ZM12 2C13.3833 2 14.6833 2.26267 15.9 2.788C17.1167 3.31333 18.175 4.02567 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7367 9.31667 21.9993 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6867 17.1167 19.9743 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7367 13.3833 21.9993 12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6867 5.825 19.9743 4.925 19.075C4.025 18.175 3.31233 17.1167 2.787 15.9C2.26167 14.6833 1.99933 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31333 6.88333 4.02567 5.825 4.925 4.925C5.825 4.025 6.88334 3.31233 8.1 2.787C9.31667 2.26167 10.6167 1.99933 12 2Z"
          fill="#A6A6A6"
        />
      </svg>
    </Box>
  );
};

const ArrowCircleUpOutlineIcon = props => {
  return (
    <Box {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 16H13V11.8L14.6 13.4L16 12L12 8L8 12L9.4 13.4L11 11.8V16ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6867 5.825 19.9743 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26333 14.6833 2.00067 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31333 6.88333 4.02567 5.825 4.925 4.925C5.825 4.025 6.88333 3.31267 8.1 2.788C9.31667 2.26333 10.6167 2.00067 12 2C13.3833 2 14.6833 2.26267 15.9 2.788C17.1167 3.31333 18.175 4.02567 19.075 4.925C19.975 5.825 20.6877 6.88333 21.213 8.1C21.7383 9.31667 22.0007 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6867 17.1167 19.9743 18.175 19.075 19.075C18.175 19.975 17.1167 20.6877 15.9 21.213C14.6833 21.7383 13.3833 22.0007 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
          fill="#A6A6A6"
          fillOpacity="0.5"
        />
      </svg>
    </Box>
  );
};

const ArrowCircleUpIcon = props => {
  return (
    <Box {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 16H13V11.8L14.6 13.4L16 12L12 8L8 12L9.4 13.4L11 11.8V16ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6867 5.825 19.9743 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26333 14.6833 2.00067 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31333 6.88333 4.02567 5.825 4.925 4.925C5.825 4.025 6.88333 3.31267 8.1 2.788C9.31667 2.26333 10.6167 2.00067 12 2C13.3833 2 14.6833 2.26267 15.9 2.788C17.1167 3.31333 18.175 4.02567 19.075 4.925C19.975 5.825 20.6877 6.88333 21.213 8.1C21.7383 9.31667 22.0007 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6867 17.1167 19.9743 18.175 19.075 19.075C18.175 19.975 17.1167 20.6877 15.9 21.213C14.6833 21.7383 13.3833 22.0007 12 22Z"
          fill="#A6A6A6"
        />
      </svg>
    </Box>
  );
};

const ArrowCircleDownOutlineIcon = props => {
  return (
    <Box {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 8L11 8L11 12.2L9.4 10.6L8 12L12 16L16 12L14.6 10.6L13 12.2L13 8ZM12 2C13.3833 2 14.6833 2.26267 15.9 2.788C17.1167 3.31333 18.175 4.02567 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7367 9.31667 21.9993 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6867 17.1167 19.9743 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7367 13.3833 21.9993 12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6867 5.825 19.9743 4.925 19.075C4.025 18.175 3.31233 17.1167 2.787 15.9C2.26167 14.6833 1.99933 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31333 6.88333 4.02567 5.825 4.925 4.925C5.825 4.025 6.88334 3.31233 8.1 2.787C9.31667 2.26167 10.6167 1.99933 12 2ZM12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4Z"
          fill="#A6A6A6"
          fillOpacity="0.5"
        />
      </svg>
    </Box>
  );
};

const WarningIcon = props => {
  return (
    <Box {...props}>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.334 9.5V14.5M12.334 18V18.5"
          stroke="#CE6641"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M2.56553 19.5163L10.6835 3.55225C11.3965 2.14925 13.2735 2.14925 13.9855 3.55225L22.1025 19.5163C22.7835 20.8603 21.8775 22.5002 20.4495 22.5002H4.21653C2.78953 22.5002 1.88253 20.8603 2.56653 19.5163H2.56553Z"
          stroke="#CE6641"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
};

export {
  ArrowCircleDownIcon,
  ArrowCircleDownOutlineIcon,
  ArrowCircleUpIcon,
  ArrowCircleUpOutlineIcon,
  SortAscIcon,
  SortDescIcon,
  WarningIcon
};
